import { createContext, useContext, useState, useEffect } from 'react';
import appConstants from '../constants/appConstants';
import { useNavigate } from 'react-router-dom';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const navigate = useNavigate();
  const [institute, setInstitute] = useState(null);
  const [user, setUser] = useState(null);
  const [selectedAcademicYear, setSelectedAcademicYear] = useState(() => {
    try {
      const raw = localStorage.getItem('selectedAcademicYear');
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  });

  useEffect(() => {
    try {
      if (selectedAcademicYear) {
        localStorage.setItem(
          'selectedAcademicYear',
          JSON.stringify(selectedAcademicYear),
        );
      } else {
        localStorage.removeItem('selectedAcademicYear');
      }
    } catch (e) {
      // ignore
    }
  }, [selectedAcademicYear]);

  const fetchInstituteData = async () => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      //navigate("/login");
      return;
    }

    try {
      const response = await fetch(
        `${appConstants.API_ROOT_URL}get-my-institute`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await response.json();
      if (response.ok) {
        setInstitute(data.data);
      } else {
        if (
          data.message === 'Expired token' ||
          data.message === 'Invalid or expired token'
        ) {
          localStorage.removeItem('authToken');
          localStorage.removeItem('userData');
          navigate('/login');
        }
      }
    } catch (error) {
      console.error('Failed to fetch institute data:', error);
    }
  };

  useEffect(() => {
    fetchInstituteData();
  }, []);

  return (
    <AppContext.Provider
      value={{
        institute,
        setInstitute,
        user,
        setUser,
        fetchInstituteData,
        selectedAcademicYear,
        setSelectedAcademicYear,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
